import {
  CHANAGEPASSWORD_FAIL,
  CHANAGEPASSWORD_REQUEST,
  CHANAGEPASSWORD_SUCCESS,
} from "../../constants/actions";
import { postData } from "../../../services/api";
import { ApiURLs } from "../../../constant/ApiUrls";
import { hideChangePassModal } from "./changePassModalDispatcher";


export const changePasswordRequest = (data, navigate) => {
  return async (dispatch) => {

    dispatch(newPassRequest());
    try {
      var newPasswordData = await postData(data, ApiURLs.CHANGE_PASSWORD);
      if (newPasswordData.status === 1) {
        dispatch(passReqSuccess());
        dispatch(hideChangePassModal())
      } else {
        dispatch(passReqFail());
      }
    } catch (error) {
      dispatch(passReqFail());

    }
  };
};

export const newPassRequest = () => {
  return {
    type: CHANAGEPASSWORD_REQUEST,
  };
};

export const passReqSuccess = () => {
  return {
    type: CHANAGEPASSWORD_SUCCESS,
  };
};

export const passReqFail = (error) => {
  return {
    type: CHANAGEPASSWORD_FAIL,
    payload: error,
  };
};
